import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });
const PADRAO = [25, 30, 35];

/** As 3 metas de CMV da loja (GET/PUT /api/settings/precificacao). Trocar uma
 *  meta vale para todos os produtos. Falhou ao gravar → volta o valor antigo. */
export default function useMetasCmv() {
  const [metas, setMetas] = useState(PADRAO);

  useEffect(() => {
    let vivo = true;
    fetch(`${API_URL}/api/settings/precificacao`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivo && Array.isArray(d?.metas) && d.metas.length === 3) setMetas(d.metas); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  const trocarMeta = useCallback(async (indice, valor) => {
    const anterior = metas;
    const novas = metas.map((m, i) => (i === indice ? valor : m));
    if (novas[indice] === anterior[indice]) return true;
    setMetas(novas);
    try {
      const r = await fetch(`${API_URL}/api/settings/precificacao`, { method: "PUT", headers: auth(), body: JSON.stringify({ metas: novas }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar a meta.");
      setMetas(d.metas);
      toast.success(`Meta de CMV salva: ${String(valor).replace(".", ",")}% (vale para todos os produtos)`);
      return true;
    } catch (e) {
      setMetas(anterior);
      toast.error(e.message);
      return false;
    }
  }, [metas]);

  return { metas, trocarMeta };
}
